export interface FigureName {
    value: string;
    label: string;
    has_backside?: boolean;
    has_angle?: boolean;
    has_stance?: boolean;
    has_rotation?: boolean;
    has_aachived?: boolean;
  }

export const figures: readonly FigureName[] = [
  { value: 'CUSTOM', label: 'Custom' },
  { value: 'OLLIE', label: 'Ollie', has_angle: true, has_stance: true, has_rotation: true, has_aachived: true },
  { value: 'KICKFLIP', label: 'Kickflip' },
  { value: 'HEELFLIP', label: 'Heelflip' },
  { value: 'POP SHOVE IT', label: 'Pop Shove-it' },
  { value: 'FRONTSIDE 180', label: 'Frontside 180' },
  { value: 'BACKSIDE 180', label: 'Backside 180' },
  { value: 'FS POP SHOVE IT', label: 'Frontside Pop Shove-it' },
  { value: 'BS POP SHOVE IT', label: 'Backside Pop Shove-it' },
  { value: 'VARIAL KICKFLIP', label: 'Varial Kickflip' },
  { value: 'VARIAL HEELFLIP', label: 'Varial Heelflip' },
  { value: 'HARDFLIP', label: 'Hardflip' },
  { value: 'INWARD HEELFLIP', label: 'Inward Heelflip' },
  { value: '360 FLIP', label: '360 Flip' },
  { value: 'TRE FLIP', label: 'Tre Flip' },
  { value: 'PRESSURE FLIP', label: 'Pressure Flip' },
  { value: 'IMPOSSIBLE', label: 'Impossible' },
  { value: 'NO COMPLY', label: 'No Comply' },
  { value: 'MANUAL', label: 'Manual' },
  { value: 'NOSE MANUAL', label: 'Nose Manual' },
  { value: 'MANUAL PAD RUN', label: 'Manual Pad Run' },
  { value: 'GRIND', label: 'Grind' },
  { value: '50 50', label: '50-50' },
  { value: 'BOARDSLIDE', label: 'Boardslide' },
  { value: 'LIPSLIDE', label: 'Lipslide' },
  { value: 'FEEBLE GRIND', label: 'Feeble Grind' },
  { value: 'SMITH GRIND', label: 'Smith Grind' },
  { value: 'CROOKED GRIND', label: 'Crooked Grind' },
  { value: 'BACKSIDE NOSE GRIND', label: 'Backside Nose Grind' },
  { value: 'FRONTSIDE NOSE GRIND', label: 'Frontside Nose Grind' },
  { value: 'BLUNT SLIDE', label: 'Blunt Slide' },
  { value: 'KICKFLIP NOSE SLIDE', label: 'Kickflip Nose Slide' },
  { value: 'NOSE GRIND TO REVERT', label: 'Nosegrind to Revert' },
  { value: 'CROOKED GRIND TO BACKSIDE TAILSLIDE', label: 'Crooked Grind to Backside Tailslide' },
  { value: 'SLAPPY', label: 'Slappy' },
  { value: 'TAIL SLIDE', label: 'Tail Slide' },
] as const;